import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import * as moment from 'moment-timezone';
import TooltipMaterial from "@material-ui/core/Tooltip";
import NumberInput from 'web/components/form-elements/NumberInput';
import TextArea from 'web/components/form-elements/TextArea';
import Button from 'web/components/Button';
import { Formik } from 'formik';
import { setInitialValuesSupplierFee, SUPPLIER_FEE_VALIDATION_SCHEMA } from './utils'
import { SupplierTermsFeeWrapper, SupplierTermsFeeTableWrapper } from './SupplierFeeManagementStyles'
import AlertModal from 'web/components/AlertModal';
import YesNoModal from 'web/components/YesNoModal';
import { fetchSupplierCompanyNamesAPI, fetchSelectedCompanyDetailsAPI, fetchSupplierTermsListDataAPI, addUpdateSupplierTermsAPI, deleteSupplierTermsAPI } from 'redux/actions/adminSupplierFeeMangement'

// table related imports
import { Table } from 'reactstrap';
import { Tooltip } from "reactstrap";
import iIcon from "web/assets/images/informationIcon.png";
import CsvDownloader from 'react-csv-downloader';
import Pagination from '@material-ui/lab/Pagination';
import EditIcon from "web/assets/svg/EditUnderlineIcon";
import DeleteIcon from "web/assets/svg/PtPlusUserDeleteIcon";
import { SearchWrapper } from '../../Admin/DashBoard/dashBoardStyled'
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'
import { AiOutlineSearch } from "react-icons/ai"
import CommentIcon from 'web/assets/svg/CommentIcon'
import { globalTermsHighlight, supplierTermsListTableHeader, supplierTermsCsvColumns, formCsvData } from "./SupplierConstants"
import { stateConvert } from 'web/components/utils/stateAbbreviation';

function SupplierFeeTermsTab({ globalFeeData }) {
  const dispatch = useDispatch();
  let history = useHistory();
  const tempDataRef = useRef(null); // hold values temporarily like id for delete, etc..
  const [isEditMode, setEditMode] = useState(false);
  const [supplierCompanyList, setSupplierCompanyList] = useState([])

  const [isLoading, setIsLoading] = useState(false)
  const [supplierListTableData, setSupplierListTableData] = useState([])
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [tableSearchText, setTableSearchText] = useState('')

  const [isExporting, setIsExporting] = useState(false)

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');

  const [yesNoModalOpen, setYesNoModalOpen] = useState(false);
  const [yesNoModalContent, setYesNoModalContent] = useState(false);

  useEffect(() => {
    fetchSupplierCompanyNames();
    fetchSupplierFeeTableData();
  }, []);

  const fetchSupplierCompanyNames = async () => {
    let response = await dispatch(fetchSupplierCompanyNamesAPI());
    if (response.success) {
      const companyNamesListTemp = response?.data?.locationDetails?.map(location => ({
        ...location,
        label: `${location.locationName}, ${location?.city} ${stateConvert(location?.state)}`,
        value: location.locationId
      }));
      setSupplierCompanyList(companyNamesListTemp || []);
    }
  }

  const fetchSupplierFeeTableData = async (props) => {
    setIsLoading(true)
    let data = {
      size: 10,
      number: props?.page ? (props?.page - 1) : ((page - 1) || 0),
      sort: "ASC",
      searchBy: tableSearchText
    }
    let response = await dispatch(fetchSupplierTermsListDataAPI(data));
    setIsLoading(false)
    if (response.success) {
      setSupplierListTableData(response.data?.lists || [])
      setTotalPages(response.data?.totalPages)
    } else {
      errorResHandle(response)
    }
  }

  const companySelectionHandler = async (selComp, formikProps, selCompDetailsFromTable) => {
    let selCompDetails // common varibale for storing data from table or from api

    // while editing the location directly set the values from the table data (selCompDetailsFromTable will have value)
    // while selecting the record from the company dropdown option, call the api to fetch location data
    // ------if selected company dont have saved record populate from global terms (available from parent comp)
    if (selCompDetailsFromTable) {
      selCompDetails = {
        ...selCompDetailsFromTable,
        label: `${selCompDetailsFromTable?.companyDetails?.companyName}, ${selCompDetailsFromTable?.companyDetails?.city} ${stateConvert(selCompDetailsFromTable?.companyDetails?.state)}`,
        value: selCompDetailsFromTable?.companyDetails?.locationId,
        locationName: selCompDetailsFromTable?.companyDetails?.companyName,
      }
    } else {
      let response = await dispatch(fetchSelectedCompanyDetailsAPI(selComp.locationId));
      if (response.success) {
        selCompDetails = response.data
      }
    }

    if (selCompDetails) {
      formikProps.setFieldValue('address', selCompDetails?.companyDetails?.address)
      formikProps.setFieldValue('company', selComp || selCompDetails)
      formikProps.setFieldValue('companyType', selCompDetails?.userRole)
      formikProps.setFieldValue('city', `${selCompDetails?.companyDetails?.city} ${stateConvert(selCompDetails?.companyDetails?.state)} ${selCompDetails?.companyDetails?.zip}`)
      formikProps.setFieldValue('contact', `${selCompDetails?.emailId}${selCompDetails?.contact ? `, ${selCompDetails?.contact}` : ''}`)
      formikProps.setFieldValue('deliveryTermDiscount', selCompDetails?.deliveryTermDiscount?.toFixed(1))
      formikProps.setFieldValue('pickupTermDiscount', selCompDetails?.pickupTermDiscount?.toFixed(1))
      formikProps.setFieldValue('comments', selCompDetails?.comments)

      // for the following if the respective values are null, then setting it from global terms
      if (selCompDetails?.paymentTerms !== null) formikProps.setFieldValue('paymentTerms', selCompDetails?.paymentTerms)
      else formikProps.setFieldValue('paymentTerms', globalFeeData?.supplierTermDelivery)

      if (selCompDetails?.collectionTerms !== null) formikProps.setFieldValue('collectionTerms', selCompDetails?.collectionTerms)
      else formikProps.setFieldValue('collectionTerms', globalFeeData?.supplierTermPickup)

      if (selCompDetails?.buyerFee !== null) formikProps.setFieldValue('buyerFee', selCompDetails?.buyerFee?.toFixed(1))
      else formikProps.setFieldValue('buyerFee', globalFeeData?.buyerFee?.toFixed(1))

      if (selCompDetails?.sellerFee !== null) formikProps.setFieldValue('sellerFee', selCompDetails?.sellerFee?.toFixed(1))
      else formikProps.setFieldValue('sellerFee', globalFeeData?.sellerFee?.toFixed(1))

      if (selCompDetails?.brokerFee !== null) formikProps.setFieldValue('brokerFee', selCompDetails?.brokerFee?.toFixed(1))
      else formikProps.setFieldValue('brokerFee', globalFeeData?.brokerFee?.toFixed(1))
    } else {
      formikProps.resetForm()
      formikProps.setFieldValue('address', [selComp?.address1, selComp?.address2].filter(Boolean).join(', '))
      formikProps.setFieldValue('company', selComp)
      formikProps.setFieldValue('companyType', selComp?.userRole)
      formikProps.setFieldValue('city', `${selComp?.city} ${stateConvert(selComp?.state)} ${selComp?.zipcode}`)
      formikProps.setFieldValue('contact', `${selComp?.emailId}${selComp?.contact ? `, ${selComp?.contact}` : ''}`)
      // when location specific data is not added populate that with the global fee data
      formikProps.setFieldValue('paymentTerms', globalFeeData?.supplierTermDelivery)
      formikProps.setFieldValue('collectionTerms', globalFeeData?.supplierTermPickup)
      formikProps.setFieldValue('buyerFee', globalFeeData?.buyerFee?.toFixed(1))
      formikProps.setFieldValue('sellerFee', globalFeeData?.sellerFee?.toFixed(1))
      formikProps.setFieldValue('brokerFee', globalFeeData?.brokerFee?.toFixed(1))
    }
    setEditMode(true)
  }

  const handleSave = async (formikProps) => {
    const values = formikProps.values;

    const dynamicPayloadKeys = {
      GUEST: ["buyerFee"],
      BUYER: ["buyerFee", "collectionTerms", "pickupTermDiscount"],
      SELLER: ["sellerFee", "paymentTerms", "deliveryTermDiscount"],
      BUYSELL: ["buyerFee", "sellerFee", "paymentTerms", "deliveryTermDiscount", "collectionTerms", "pickupTermDiscount",],
      BROKER: ["brokerFee", "paymentTerms", "deliveryTermDiscount", "collectionTerms", "pickupTermDiscount",],
    };

    let data = {
      locationId: values?.company?.locationId,
      buyerFee: null,
      sellerFee: null,
      brokerFee: null,
      paymentTerms: null,
      deliveryTermDiscount: null,
      collectionTerms: null,
      pickupTermDiscount: null,
      comments: values?.comments,
    };

    const parseNum = (val) => val !== null && val !== undefined && val !== "" ? parseFloat(val) : null;

    // setting the terms based on the company type
    (dynamicPayloadKeys[values.companyType] || []).forEach((field) => {
      let val = parseNum(values?.[field]);
      // if specific terms not set for a supplier, by default global terms should be set (buyer, seller, broker-fees && payment, collection-days - these 5)
      if (val === null) {
        if (field === "paymentTerms") val = globalFeeData?.supplierTermDelivery;
        else if (field === "collectionTerms") val = globalFeeData?.supplierTermPickup;
        else if (field !== "deliveryTermDiscount" && field !== "pickupTermDiscount") val = globalFeeData?.[field]; // these two should NOT fallback from global
      }
      data[field] = val
    });

    let response = await dispatch(addUpdateSupplierTermsAPI(data));
    if (response.success) {
      setModalContent(response.data?.msg);
      setModal(!modal);
      formikProps.resetForm();
      setEditMode(false);
      fetchSupplierFeeTableData()
    } else {
      errorResHandle(response);
    }
  };

  const handleDelete = async () => {
    const data = tempDataRef.current;
    let response = await dispatch(deleteSupplierTermsAPI(data.id));
    if (response.success) {
      setModalContent(response.data?.msg);
      setModal(!modal);
      setPage(1);
      fetchSupplierFeeTableData({ page: 1 })
      tempDataRef.current = null;
    } else {
      errorResHandle(response);
    }
  }

  const errorResHandle = (response) => {
    if (response.statusCode === 401) {
      localStorage.removeItem('token')
      history.push('/sign-in')
      window.location.reload(false);
    } else {
      setModalContent(response.message || 'Something went wrong, please try again!')
      setModal(!modal)
    }
  }

  const handleSearch = (e) => {
    let searchText = e.target.value
    setTableSearchText(searchText)
    setPage(1)
  }

  const handlePageChange = (event, value) => {
    setPage(value)
    fetchSupplierFeeTableData({ page: value })
  }

  const exportSupplierFeeData = async () => {
    setIsExporting(true)
    let allData = [];
    let currentPage = 0;
    let totalPages = 1;

    while (currentPage < totalPages) {
      let data = {
        size: 100,
        number: currentPage,
        sort: "ASC",
        searchBy: tableSearchText
      };

      let response = await dispatch(fetchSupplierTermsListDataAPI(data, 'noLoader'));

      if (response.success) {
        const pageData = response.data?.lists || [];
        allData = [...allData, ...pageData];
        totalPages = response.data?.totalPages || 1;
        currentPage++;
      } else {
        errorResHandle(response);
        break;
      }
    }

    if (allData?.length > 0) {
      const csvDataList = formCsvData(allData)
      setIsExporting(false)
      return csvDataList
    }
  };


  const checkDisabled = (values) => {
    const { companyType } = values;
    return (
      !values.paymentTerms || !values.collectionTerms ||
      (['BUYER', 'BUYSELL', 'BROKER'].includes(companyType) && !values.buyerFee) ||
      (['SELLER', 'BUYSELL', 'BROKER'].includes(companyType) && !values.sellerFee) ||
      (companyType === 'BROKER' && !values.brokerFee)
    );
  };

  const [toolTipOpen, setTooltipOpen] = useState(false);
  const [toolTipSection, setTooltipSection] = useState("");
  const toolTipInfo = (infoSection, infoTxt) => {
    return (
      <>
        <img
          id={infoSection}
          src={iIcon}
          style={{ position: "relative", top: "-1px", marginLeft: "6px", }}
        />
        <Tooltip
          placement="right"
          isOpen={toolTipOpen && toolTipSection === infoSection}
          target={infoSection}
          toggle={() => {
            setTooltipOpen(!toolTipOpen);
            setTooltipSection(toolTipSection === "" ? infoSection : "");
          }}>
          {infoTxt}
        </Tooltip>
      </>
    );
  };

  return (
    <>
      <Formik
        initialValues={setInitialValuesSupplierFee()}
        validationSchema={SUPPLIER_FEE_VALIDATION_SCHEMA}
        onSubmit={_ => { }}>
        {(formikProps) => {
          const { isValid, dirty, values } = formikProps;
          return (
            <>
              <SupplierTermsFeeWrapper>
                <div>
                  <div className='global-terms-table'>
                    <h6 className='global-terms-header'>Global Terms</h6>
                    <Table responsive>
                      <thead>
                        <tr className='global-terms-table-header'>
                          {globalTermsHighlight.map((items, index) => (
                            <th key={index}>{items.title}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        <tr className='global-terms-table-content'>
                          <td>{globalFeeData?.sellerFee?.toFixed(1) || 0.0} %</td>
                          <td>{globalFeeData?.buyerFee?.toFixed(1) || 0.0} %</td>
                          <td>{globalFeeData?.brokerFee?.toFixed(1) || 0.0} %</td>
                          <td>{globalFeeData?.ptPlusSellerFee?.toFixed(1) || 0.0} %</td>
                          <td>{globalFeeData?.ptPlusBuyerFee?.toFixed(1) || 0.0} %</td>
                          <td>{globalFeeData?.supplierTermDelivery} days</td>
                          <td>{globalFeeData?.supplierTermPickup} days</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>

                  <div className="global-fee-section">
                    <div className="form-field">
                      <Select
                        id="companyId"
                        name="company"
                        classNamePrefix="supplier-select"
                        value={values?.company}
                        onChange={(selComp) => companySelectionHandler(selComp, formikProps)}
                        options={supplierCompanyList}
                        placeholder="Select Supplier"
                      />
                    </div>
                  </div>

                  {isEditMode &&
                    <>
                      <div className='instructions'>
                        The following table reflects Suppliers with exceptions to the Global System Terms and/or Fees.
                      </div>

                      <div className="global-fee-section location-details">
                        <div>{values?.company?.locationName}</div>
                        <div>{values?.address}, {values?.city}</div>
                        {values?.companyType ? <div>{values?.contact}</div> : <div className='no-users'>*No users have been added for this location yet.</div>}
                      </div>

                      {values?.companyType &&
                        <>
                          {values.companyType !== 'GUEST' &&
                            <div className="global-fee-section">
                              <h3 className="global-fee-section-title">PalletTrader+ Terms</h3>
                              <div className="fee-wrapper">
                                {values.companyType !== 'BUYER' &&
                                  <div className="form-field-wrapper">
                                    <div className="form-field">
                                      <label className="form-label">
                                        Payment Terms on Deliveries
                                      </label>
                                      <div className='form-value'>
                                        <NumberInput name="paymentTerms" maxAllowedValueLimit={999} fieldType="percentage" decimalLimit={0} />days
                                      </div>
                                    </div>
                                    <div className="form-field">
                                      <label className="form-label discount-rate">
                                        Discount
                                      </label>
                                      <div className='form-value'>
                                        <NumberInput name="deliveryTermDiscount" fieldType="percentage" maxAllowedValueLimit={100} decimalLimit={1} />%
                                      </div>
                                    </div>
                                  </div>
                                }
                                {values.companyType !== 'SELLER' &&
                                  <div className="form-field-wrapper">
                                    <div className="form-field">
                                      <label className="form-label">
                                        Collection Terms on Pickups
                                      </label>
                                      <div className='form-value'>
                                        <NumberInput name="collectionTerms" maxAllowedValueLimit={999} fieldType="percentage" decimalLimit={0} />days
                                      </div>
                                    </div>
                                    <div className="form-field">
                                      <label className="form-label discount-rate">
                                        Discount
                                      </label>
                                      <div className='form-value'>
                                        <NumberInput name="pickupTermDiscount" fieldType="percentage" maxAllowedValueLimit={100} decimalLimit={1} />%
                                      </div>
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          }

                          <div className="global-fee-section">
                            <h3 className="global-fee-section-title">Management Fee on PT.com</h3>
                            <div className="fee-wrapper">
                              {['SELLER', 'BUYSELL'].includes(values.companyType) &&
                                <div className="form-field">
                                  <label className="form-label">
                                    Seller Fee (%)
                                  </label>
                                  <div className='form-value'>
                                    <NumberInput name="sellerFee" fieldType="percentage" maxAllowedValueLimit={100} decimalLimit={1} />%
                                  </div>
                                </div>
                              }
                              {['BUYER', 'BUYSELL', 'GUEST'].includes(values.companyType) &&
                                <div className="form-field">
                                  <label className="form-label">
                                    Buyer Fee (%)
                                  </label>
                                  <div className='form-value'>
                                    <NumberInput name="buyerFee" fieldType="percentage" maxAllowedValueLimit={100} decimalLimit={1} />%
                                  </div>
                                </div>
                              }
                              {values.companyType === 'BROKER' &&
                                <div className="form-field">
                                  <label className="form-label">
                                    Broker Fee (%)
                                  </label>
                                  <div className='form-value'>
                                    <NumberInput name="brokerFee" fieldType="percentage" maxAllowedValueLimit={100} decimalLimit={1} />%
                                  </div>
                                </div>
                              }
                            </div>
                          </div>

                          <div className="form-field comments-styling">
                            <label className="form-label">
                              Comments
                            </label>
                            <div className='form-value-text-area'>
                              <TextArea
                                name="comments"
                                inputType="textAndNumber"
                                maxLength='500'
                              />
                            </div>
                          </div>

                          <div className="button-group">
                            <Button
                              type="app-green-button submitBtn"
                              // disabled={checkDisabled(formikProps.values)}
                              handleClick={() => {
                                handleSave(formikProps)
                              }}
                            >
                              Save Variables
                            </Button>
                          </div>
                        </>
                      }
                    </>}
                </div>
              </SupplierTermsFeeWrapper>
              <SupplierTermsFeeTableWrapper>
                <TableWrapper>
                  <Heading style={{ minHeight: '40px' }}>
                    <h3 style={{ fontSize: '16px' }}>Supplier Discount Program & Terms: Exceptions to Global Settings</h3>
                    <div className='d-flex flex-wrap flex-sm-nowrap'>
                      <SearchWrapper>
                        <input
                          type="text"
                          placeholder='Search'
                          value={tableSearchText}
                          onChange={handleSearch}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              fetchSupplierFeeTableData();
                            }
                          }}
                        />
                        <AiOutlineSearch />
                      </SearchWrapper>
                      <button className='search-submit' onClick={fetchSupplierFeeTableData}>Submit</button>
                      <CsvDownloader
                        filename="Supplier Terms"
                        columns={supplierTermsCsvColumns}
                        datas={exportSupplierFeeData}>
                        <button
                          className={`export ${isExporting ? 'is-exporting' : ''}`}
                          disabled={isExporting}
                        >
                          {isExporting ? <span className='exporting'>Exporting...</span> : 'Export'}
                        </button>
                      </CsvDownloader>
                    </div>
                  </Heading>
                  <Table responsive>
                    <thead>
                      <tr>
                        {supplierTermsListTableHeader.map((items, index) => (
                          <th key={index}>{items.title} {items?.infotText && <span>{toolTipInfo(items.id, items?.infotText)}</span>}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {
                        supplierListTableData?.map((items, index) => (
                          <tr key={index}>
                            <td>
                              <TooltipMaterial
                                placement="top"
                                arrow
                                title={`${items.companyDetails?.companyName}, ${items.companyDetails?.address}, ${items.companyDetails?.city} ${stateConvert(items.companyDetails?.state) || items.companyDetails?.state}`}
                                enterTouchDelay={0}
                              >
                                <span className="ellipsis">{items.companyDetails?.companyName}, {items.companyDetails?.address}, {items.companyDetails?.city} {stateConvert(items.companyDetails?.state) || items.companyDetails?.state}</span>
                              </TooltipMaterial>
                            </td>
                            <td>{items.paymentTerms !== null ? `${items.paymentTerms} Days` : 'NA'}</td>
                            <td>{items.deliveryTermDiscount !== null ? `${items.deliveryTermDiscount?.toFixed(1)} %` : 'NA'}</td>
                            <td>{items.collectionTerms !== null ? `${items.collectionTerms} Days` : 'NA'}</td>
                            <td>{items.pickupTermDiscount !== null ? `${items.pickupTermDiscount?.toFixed(1)} %` : 'NA'}</td>
                            <td>{items.sellerFee !== null ? `${items.sellerFee?.toFixed(1)} %` : 'NA'}</td>
                            <td>{items.buyerFee !== null ? `${items.buyerFee?.toFixed(1)} %` : 'NA'}</td>
                            <td>{items.brokerFee !== null ? `${items.brokerFee?.toFixed(1)} %` : 'NA'}</td>
                            <td className='date-time'>{moment.utc(items?.feeDateTime).tz("America/New_York").format("MM/DD/YYYY, hh:mm A")}</td>
                            <td>
                              {items.comments?.trim() ?
                                <TooltipMaterial
                                  placement="top"
                                  arrow
                                  title={items?.comments?.trim()}
                                  enterTouchDelay={0}
                                >
                                  <span className="comments"><CommentIcon /></span>
                                </TooltipMaterial>
                                :
                                <span className="comments">NA</span>
                              }
                            </td>
                            <td>
                              <div className='action-buttons'>
                                <span className='editicon' onClick={() => companySelectionHandler(undefined, formikProps, items)}><EditIcon /></span>
                                <span onClick={() => {
                                  tempDataRef.current = items;
                                  setYesNoModalOpen(true)
                                  setYesNoModalContent('Are you sure you want to delete?')
                                }}><DeleteIcon /></span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      {!isLoading && (!supplierListTableData || supplierListTableData?.length === 0) && <td colSpan={10} className='no-records'>No Records Found</td>}
                    </tbody>
                  </Table>
                  {supplierListTableData?.length > 0 &&
                    <Pagination
                      count={totalPages}
                      page={page}
                      onChange={handlePageChange}
                    />
                  }
                </TableWrapper>
              </SupplierTermsFeeTableWrapper >
            </>
          );
        }}
      </Formik >

      <AlertModal
        isOpen={modal}
        toggle={() => setModal(!modal)}
        title=''
        content={modalContent}
      />

      <YesNoModal
        isOpen={yesNoModalOpen}
        toggle={() => setYesNoModalOpen(!yesNoModalOpen)}
        onClickHander={(val) => {
          if (val === "no") setYesNoModalOpen(false)
          else handleDelete()
        }}
        content={yesNoModalContent}
        link="/"
      />
    </>
  )
}

export default SupplierFeeTermsTab